import Hero from "../Component/Hero";
import AlurPeminjaman from "../Component/AlurPeminjaman";
import AllProductProduktif from "../Component/AllProductProduktif";

function PinjamanUsaha() {
    return (
        <>
            <div>
                <Hero
                    imageClass='usaha'
                    title='Pinjaman Usaha'
                    subTitle='P I N J A M A N &emsp;P R O D U K T I F'
                    explanation='
                        Fasilitas pinjaman yang diberikan bagi pelaku usaha untuk mendapatkan modal kerja.
                        <br/><br/>
                        Fasilitas modal usaha ini tidak memerlukan aset tetap <em>(fixed asset)</em> sebagai jaminan, hanya dengan menggunakan <em>invoice</em>/ tagihan <em>(Invoice Financing)</em> atau barang persediaan <em>(Inventory Financing)</em> sebagian jaminan.'
                />
                <AllProductProduktif/>
                <AlurPeminjaman type='produktif'/>
            </div>
        </>
    );
}

export default PinjamanUsaha;
